<template>
  <div class="admin-user-form">
    <el-card>
      <div slot="header">
        <span>{{ isEdit ? '编辑账号' : '新增账号' }}</span>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="max-width:560px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名" :disabled="isEdit" />
        </el-form-item>
        <el-form-item :label="isEdit ? '新密码' : '密码'" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            show-password
            :placeholder="isEdit ? '留空则不修改密码' : '请输入密码（至少6位）'"
          />
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="form.nickname" placeholder="请输入昵称" />
        </el-form-item>
        <el-form-item label="角色">
          <el-switch
            v-model="form.is_super"
            :active-value="1"
            :inactive-value="0"
            active-text="超级管理员"
            inactive-text="普通管理员"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>

        <el-form-item label="网站权限" v-if="!form.is_super">
          <el-transfer
            v-model="form.website_ids"
            :data="allWebsites"
            :titles="['可选网站', '可查看网站']"
            :button-texts="['移除', '添加']"
            filterable
            filter-placeholder="搜索网站"
          />
          <div style="font-size:12px;color:#909399;margin-top:4px">
            该用户只能查看已选网站的数据
          </div>
        </el-form-item>

        <el-form-item v-if="form.is_super">
          <el-alert title="超级管理员可查看所有网站数据" type="warning" :closable="false" show-icon />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm">保存</el-button>
          <el-button @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { adminUserApi, websiteApi } from '../api';

export default {
  name: 'AdminUserForm',
  data() {
    const validatePass = (rule, value, callback) => {
      if (!this.isEdit && (!value || value.length < 6)) {
        callback(new Error('密码至少6位'));
      } else if (this.isEdit && value && value.length < 6) {
        callback(new Error('密码至少6位'));
      } else {
        callback();
      }
    };
    return {
      isEdit: false,
      form: {
        username: '',
        password: '',
        nickname: '',
        is_super: 0,
        status: 1,
        website_ids: []
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }]
      },
      allWebsites: []
    };
  },
  mounted() {
    this.loadWebsites();
    if (this.$route.params.id) {
      this.isEdit = true;
      this.loadDetail();
    }
  },
  methods: {
    async loadWebsites() {
      try {
        const res = await websiteApi.list({ page: 1, page_size: 9999 });
        if (res.code === 0) {
          this.allWebsites = res.data.list.map(w => ({
            key: w.id,
            label: w.name + ' (' + w.domain + ')'
          }));
        }
      } catch (e) { console.error(e); }
    },
    async loadDetail() {
      try {
        const res = await adminUserApi.detail(this.$route.params.id);
        if (res.code === 0) {
          this.form = {
            id: res.data.id,
            username: res.data.username,
            password: '',
            nickname: res.data.nickname || '',
            is_super: res.data.is_super,
            status: res.data.status,
            website_ids: res.data.website_ids || []
          };
        }
      } catch (e) {
        this.$message.error('加载失败');
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        try {
          const data = { ...this.form };
          if (this.isEdit && !data.password) {
            delete data.password;
          }
          const res = await adminUserApi[this.isEdit ? 'update' : 'create'](data);
          if (res.code === 0) {
            this.$message.success(this.isEdit ? '更新成功' : '创建成功');
            this.$router.push('/admin-users');
          } else {
            this.$message.error(res.msg);
          }
        } catch (e) {
          this.$message.error('操作失败');
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
